import { render } from "./Activations.vue?vue&type=template&id=4567efac&scoped=true"
import script from "./Activations.vue?vue&type=script&lang=js"
export * from "./Activations.vue?vue&type=script&lang=js"

import "./Activations.vue?vue&type=style&index=0&id=4567efac&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4567efac"]])

export default __exports__